import { Identity } from "@equipmentshare/auth0-react";
import { pipe } from "fp";
import { useSelector } from "~/State";

export type Context = {
  /** The `baseURL` of the web application */
  readonly baseURL: string;

  readonly api: {
    /** The `baseURL` API */
    readonly baseURL: string;
  };

  readonly viewer: { readonly token: string };
  readonly identity: Identity;
};

export const isProductionEnvironment = (): boolean =>
  !(
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("staging")
  );

export const isLocalDevelopment = (): boolean =>
  window.location.hostname.includes("localhost");

export const initial = (identity: Identity): Context =>
  pipe(
    // eslint-disable-next-line no-constant-condition
    isProductionEnvironment()
      ? ["https://api.equipmentshare.com", "https://app.estrack.com"]
      : [
          "https://staging-api.equipmentshare.com",
          "https://staging-app.estrack.com",
        ],
    ([apiBaseURL, baseURL]) => ({
      baseURL,
      api: { baseURL: apiBaseURL },
      viewer: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment
        token: identity.accessToken,
      },
      identity,
    })
  );

export const useContext = (): Context => useSelector(({ context }) => context);
export const useBaseURL = (): string =>
  useSelector(({ context: { baseURL } }) => baseURL);
